var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { width: "1176px" }, attrs: { id: "home" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "padding_30px_bottom",
              attrs: { span: 24 },
            },
            [
              _c(
                "el-row",
                { staticClass: "padding_20px_bottom" },
                [
                  _c(
                    "el-col",
                    { staticClass: "home_title", attrs: { span: 18 } },
                    [
                      _c("div", { staticClass: "font_title_email" }, [
                        _vm._v(_vm._s(_vm.account)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "img_logo" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "font_title_bold" }, [
                        _vm._v("欢迎登录晨星客户端"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticClass: "logout",
                      attrs: { span: 5 },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logoutAccount.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("[退出登录]")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "select_function padding_20px_bottom" },
                    [_vm._v("\n          请选择以下功能\n        ")]
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "div",
                      { staticClass: "home_box" },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass:
                              "home_background_suitability padding_20px_bottom",
                            staticStyle: { "border-radius": "30px" },
                            attrs: { shadow: "hover" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleSuitability.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "home_padding_top" },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_title" },
                                      [
                                        _vm._v(
                                          "\n                    销售适当性\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_content" },
                                      [
                                        _vm._v(
                                          "提供全市场基金定期更新的风险等级数据，同时包括方法论说明、基金公司审慎调查报告以及基金风险评价报告\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "home_box", attrs: { span: 8 } },
                    [
                      _c(
                        "div",
                        { staticClass: "home_box" },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass:
                                "home_background_rank padding_20px_bottom",
                              staticStyle: { "border-radius": "30px" },
                              attrs: { shadow: "hover" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handleRanking.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "el-col",
                                { staticClass: "home_padding_top" },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { staticClass: "home_list_title" },
                                        [
                                          _vm._v(
                                            "\n                    基金排行榜\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { staticClass: "home_list_content" },
                                        [
                                          _vm._v(
                                            "基于晨星独有的分类方法及数据支持，针对中国市场基金定期更新中长期业绩排行榜\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "div",
                      { staticClass: "home_box" },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass:
                              "home_background_module padding_20px_bottom",
                            staticStyle: { "border-radius": "30px" },
                            attrs: { shadow: "hover" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleMorningstarAward.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "home_padding_top" },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_title" },
                                      [
                                        _vm._v(
                                          "\n                    晨星基金奖\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_content" },
                                      [
                                        _vm._v(
                                          "年度基金奖是晨星基金评价体系的重要组成部分，对长期业绩表现突出且当年度获得良好回报的国内基金管理团队给予肯定\n\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "padding-top": "60px" } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "div",
                      { staticClass: "home_box" },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass:
                              "home_background_manager padding_20px_bottom",
                            staticStyle: { "border-radius": "30px" },
                            attrs: { shadow: "hover" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleManagerTagging.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "home_padding_top" },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_title" },
                                      [
                                        _vm._v(
                                          "\n                    基金经理分析\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_content" },
                                      [
                                        _vm._v(
                                          "定量与定性结合分析基金经理的管理规模、任职回报、风格标签与持仓偏好等\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "div",
                      { staticClass: "home_box" },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass:
                              "home_background_evaluate padding_20px_bottom",
                            staticStyle: { "border-radius": "30px" },
                            attrs: { shadow: "hover" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleCompanyEvaluate.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "home_padding_top" },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_title" },
                                      [
                                        _vm._v(
                                          "\n                    基金公司分析\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_content" },
                                      [
                                        _vm._v(
                                          "从管理规模、资金流、产品线、综合业绩、管理团队等量化数据维度对中国公募基金管理人进行分析\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "home_box", attrs: { span: 8 } },
                    [
                      _c(
                        "div",
                        { staticClass: "home_box" },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass:
                                "home_background_assetAllocation padding_20px_bottom",
                              staticStyle: { "border-radius": "30px" },
                              attrs: { shadow: "hover" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handlePortfolio.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "el-col",
                                { staticClass: "home_padding_top" },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { staticClass: "home_list_title" },
                                        [
                                          _vm._v(
                                            "\n                    组合风险评价\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { staticClass: "home_list_content" },
                                        [
                                          _vm._v(
                                            "晨星组合风险评价根据持仓基金穿透到底层的实际资产分布确定持仓风险，同时结合组合过往的业绩风险指标综合确定\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "padding-top": "60px" } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "div",
                      { staticClass: "home_box" },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass:
                              "home_background_diagnosis padding_20px_bottom",
                            staticStyle: { "border-radius": "30px" },
                            attrs: { shadow: "hover" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handlePortfolioAnalyst.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "home_padding_top" },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_title" },
                                      [
                                        _vm._v(
                                          "\n                    组合诊断\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_content" },
                                      [
                                        _vm._v(
                                          "支持组合层面的业绩回测、资产分布与风格分析，也包括对持仓基金的业绩、风险、相关性以及管理人等维度指标\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "div",
                      { staticClass: "home_box" },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass:
                              "home_background_analysis padding_20px_bottom",
                            staticStyle: { "border-radius": "30px" },
                            attrs: { shadow: "hover" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleAnalyst.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "home_padding_top" },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_title" },
                                      [
                                        _vm._v(
                                          "\n                    定性评级\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_content" },
                                      [
                                        _vm._v(
                                          "晨星基金定性评级具备前瞻性分析，晨星分析师对入围基金分别给予金牌、银牌、铜牌以及中性评价\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "div",
                      { staticClass: "home_box" },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass:
                              "home_background_settings padding_20px_bottom",
                            staticStyle: { "border-radius": "30px" },
                            attrs: { shadow: "hover" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleInformation.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "home_padding_top" },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_title" },
                                      [
                                        _vm._v(
                                          "\n                    账户管理\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { staticClass: "home_list_content" },
                                      [
                                        _vm._v(
                                          "设置您的账号名称、登录邮箱、密码和联系方式等，并且查看您的服务权限\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("br"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }